/***
* Add by jfzhu
* created:20190806
* 注:商家联盟拓客领取红包页面
*/
<template>
  <div class="MerTokerGetredenvelope">
    <div class="redenvelope" v-show="redpack" :style="{height:winheight+'px'}">
      <div class="aa"></div>
      <div class="redpack">
        <div class="red_top"></div>
        <img @click="getData()" class="red_btn" src="../../resource/img/red_btn.png"/><br/>
        <img class="logo" :src="imageUrl+logo"><br/>
        <span class="texbottom">恭喜发财，大吉大利</span>
      </div>
    </div>
    <div class="detail" v-show="details">
      <div class="top">
        <img class="logo" :src="imageUrl+logo"><br/>
        <span class="texbottom">恭喜发财，大吉大利</span><br/>
        <span class="money">￥{{ urlParam.totolMoney }}</span>
      </div>
      <div class="bottoms"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MerTokerGetredenvelope',
  data () {
    return {
      urlParam: {},
      winheight: '',
      redpack: true,
      details: false,
      logo: this.$common.activitydata.pic,
      imageUrl: sessionStorage.url
    }
  },
  created () {
    this.winheight = window.screen.availHeight - 80
    if (this.$route.query) {
      this.urlParam = this.$route.query
    }
  },
  methods: {
    getData () {
      this.$api.post({
        url: '/merchant/api/activity/spread-list/get/red-paper',
        data: this.urlParam,
        login: false
      }).then(res => {
        this.details = true
        this.redpack = false
      })
    },
  }
}
</script>

<style scoped>
.MerTokerGetredenvelope {
  width: 100%;
  height: auto;
  margin-top: 40px;
}

.redenvelope {
  width: 100%;
  background-color: #000;
}

.redpack {
  width: 65%;
  height: 400px;
  margin-left: 17.5%;
  background-image: url("../../resource/img/red_b.png");
  background-size: 100% 100%;
  text-align: center;
}

.aa {
  width: 100%;
  height: 100px;
}

.red_top {
  width: 100%;
  height: 80px;
  background-image: url("../../resource/img/red_top.png");
  -webkit-background-size: 100% 100%;
  background-size: 100% 100%;
}

.red_btn {
  width: 80px;
  height: 80px;
  margin-top: -40px;
}

.logo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-top: 10px;
}

.texbottom {
  color: #FABF54;
  font-size: 17px;
}

.detail {
  width: 100%;
  height: 600px;
  text-align: center;
  background-color: #D0302C;
}

.top {
  width: 100%;
  height: 500px;
}

.money {
  color: #FABF54;
  font-size: 95px;
  line-height: 200px;
}

.bottoms {
  width: 100%;
  height: 100px;
  background-image: url("../../resource/img/tuoyuan1.png");
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/active/MerTokerGetredenvelope.vue